<template>
  <div v-if="!idProf" class="text-muted text-center py-10">
    Selecione um profissional para ver a agenda.
  </div>
  <div v-else-if="loading" class="text-center py-10">
    <span class="spinner-border text-primary"></span>
  </div>
  <div v-else class="sw-week">
    <section
      v-for="day in days"
      :key="day"
      class="sw-week__col"
      :class="{
        'is-selected': day === selectedDate,
        'is-today': day === today,
      }"
    >
      <button type="button" class="sw-week__head" @click="$emit('select-day', day)">
        <span>{{ weekdayShort(day) }}</span>
        <b>{{ day.slice(-2) }}</b>
        <small>{{ countLabel(day) }}</small>
      </button>
      <ScheduleAgendaItem
        v-for="item in itemsOn(day)"
        :key="item.id_sched || item.schedule_date_time"
        :schedule="item"
        @open="$emit('open-schedule', $event)"
      />
      <p v-if="!itemsOn(day).length" class="sw-week__empty">Sem consultas</p>
    </section>
  </div>
</template>

<script>
import moment from '../../../helpers/date';
import { isPatientSchedule, schedulesOnDate, weekdayShort } from '../../../helpers/scheduleDay';
import ScheduleAgendaItem from './ScheduleAgendaItem.vue';

export default {
  name: 'ScheduleWeekGrid',
  components: { ScheduleAgendaItem },
  props: {
    days: { type: Array, required: true },
    schedules: { type: Array, default: () => [] },
    selectedDate: { type: String, required: true },
    idProf: { default: null },
    loading: { type: Boolean, default: false },
  },
  emits: ['select-day', 'open-schedule'],
  computed: {
    today() {
      return moment().format('YYYY-MM-DD');
    },
  },
  methods: {
    weekdayShort,
    itemsOn(day) {
      return schedulesOnDate(this.schedules, day);
    },
    countLabel(day) {
      const count = this.itemsOn(day).filter(isPatientSchedule).length;
      if (!count) return 'Livre';
      return count === 1 ? '1 consulta' : `${count} consultas`;
    },
  },
};
</script>

<style scoped>
.sw-week {
  display: grid;
  grid-template-columns: repeat(7, minmax(132px, 1fr));
  gap: 0.45rem;
  overflow-x: auto;
}
.sw-week__col {
  min-width: 0;
  min-height: 420px;
  padding: 0.55rem 0.45rem 0.7rem;
  background: #f9f9fb;
  border-radius: 0.65rem;
}
.sw-week__col.is-selected {
  background: #f8f5f7;
  box-shadow: inset 0 0 0 1px #780f5a;
}
.sw-week__col.is-today:not(.is-selected) {
  box-shadow: inset 0 0 0 1px #d8dbe6;
}
.sw-week__head {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 0.55rem;
  padding: 0;
  border: 0;
  background: transparent;
  text-align: left;
  color: #181c32;
}
.sw-week__head span {
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #a1a5b7;
}
.sw-week__head b {
  font-size: 1.25rem;
  line-height: 1.2;
}
.sw-week__head small {
  color: #7e8299;
  font-size: 0.78rem;
  font-weight: 600;
}
.sw-week__empty {
  margin: 0;
  color: #c4cada;
  font-size: 0.8rem;
}
</style>
